module.exports = "/_next/static/images/a447ae6918eea5e094f483bea4f43eb2-nobureaucracy@2x.png.webp";